<template>
  <v-container v-if="player">
    <v-row
      align="center"
      no-gutters
    >
      <v-col cols="auto">
        <v-btn
          icon
          exact
          @click="!fromRoute ? $router.push({ name: 'players' }) : $router.push(fromRoute)"
        >
          <v-icon small>
            fas fa-arrow-left
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
      >
        <div class="title text-uppercase font-weight-medium">
          {{ player.description }}
        </div>
      </v-col>
      <!--      <v-spacer />-->
      <!--      <v-col-->
      <!--        cols="auto"-->
      <!--        class="body-2"-->
      <!--      >-->
      <!--        Last Sync: {{ $dayjs(player.last_sync_at).format('DD.MM.YYYY. HH:mm:ss') }}-->
      <!--      </v-col>-->
      <!--      <v-col cols="auto">-->
      <!--        <v-btn-->
      <!--          icon-->
      <!--          class="ma-0 mr-2"-->
      <!--        >-->
      <!--          <v-icon-->
      <!--            small-->
      <!--          >-->
      <!--            fas fa-sync-->
      <!--          </v-icon>-->
      <!--        </v-btn>-->
      <!--      </v-col>-->
    </v-row>

    <v-row v-if="$vuetify.breakpoint.xsOnly">
      <v-col cols="auto">
        <v-chip
          small
          :color="player.player_status === 'online' ? 'green darken-1' : 'red darken-1'"
          text-color="white"
          dark
          class="ma-0"
        >
          {{ player.player_status === 'online' ? 'Online' : 'Offline' }}
        </v-chip>
      </v-col>
      <v-col
        v-if="player.sync_progress > 0 && player.sync_progress < 1"
        cols="auto"
      >
        <v-chip
          outlined
          color="secondary"
          class="text-caption"
          small
        >
          <v-avatar left>
            <v-progress-circular
              :value="player.sync_progress * 100"
              :width="2"
              :size="16"
            />
          </v-avatar>
          Downloading ({{ player.sync_progress | percent }})
        </v-chip>
      </v-col>
    </v-row>

    <v-bottom-navigation
      v-if="$vuetify.breakpoint.xsOnly"
      app
      color="secondary"
      grow
      horizontal
    >
      <v-btn :to="{ name: 'player', params: { id: $route.params.id }}">
        <span>Radio</span>
        <v-icon x-small>
          fa fa-play-circle
        </v-icon>
      </v-btn>
      <v-btn :to="{ name: 'playerLog', params: { id: $route.params.id }}">
        <span>Playback Log</span>
        <v-icon x-small>
          fa fa-list
        </v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-tabs
      v-if="!$vuetify.breakpoint.xsOnly && !player.stream"
      background-color="transparent"
    >
      <v-tab
        class="text-none"
        :to="{ name: 'player', params: { id: $route.params.id }}"
        exact
      >
        Details
      </v-tab>
      <v-tab
        class="text-none"
        :to="{ name: 'playerLog', params: { id: $route.params.id }}"
        exact
      >
        Log
      </v-tab>
    </v-tabs>
    <v-divider v-if="!$vuetify.breakpoint.xsOnly && !player.stream" />
    <v-fade-transition mode="out-in">
      <router-view
        v-if="player"
        :key="player.id"
        :player="player"
        @update="fetchPlayer()"
      />
    </v-fade-transition>

    <edit-player-dialog
      v-if="player"
      :visible.sync="editPlayerDialog.visible"
      :player="player"
      @player:updated="fetchPlayer()"
      @player:deleted="$router.push({ name: 'players' })"
    />

    <confirm-delete-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :deleting="deleting"
      @confirm="deletePlayer()"
    />
  </v-container>
</template>

<script>
// @ is an alias to /src

import Players from '@/services/Players'
import EditPlayerDialog from '@/components/players/EditPlayerDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'
import Echo from '@/plugins/echo'

export default {
  name: 'Player',
  components: {
    ConfirmDeleteDialog,
    EditPlayerDialog
  },
  mixins: [deleteConfirmationMixin],
  data() {
    return {
      player: undefined,
      loading: false,
      clocks: {
        loading: false,
        data: []
      },
      editPlayerDialog: {
        visible: false,
        clone: false
      },
      fromRoute: null
    }
  },
  watch: {
    '$route.params.id': function () {
      this.fetchPlayer()
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from
    })
  },
  created() {
    this.fetchPlayer()

    Echo.private('superadmin').listen('PlayerUpdated', (player) => {
      if (player.id !== this.player.id) return

      this.player = player
    })
  },
  beforeDestroy() {
    Echo.leave('superadmin')
  },
  methods: {
    async fetchPlayer() {
      this.loading = true

      try {
        this.player = await Players.get(this.$route.params.id)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async deletePlayer() {
      this.deleting = true

      try {
        await Players.delete(this.player.id)

        this.$store.dispatch('alert', {
          text: 'Successfully deleted',
          color: 'success'
        })

        this.$router.push({ name: 'players' })
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'Something went wrong',
          color: 'error'
        })
        throw e
      } finally {
        this.deleteConfirmationDialogVisible = false
        this.deleting = false
      }
    }
  }
}
</script>
